import { motion } from 'motion/react';

const products = [
  {
    id: 1,
    name: 'Smartphones',
    tagline: 'iPhone · Samsung · OnePlus · Vivo · OPPO · Xiaomi',
    image: 'https://public.readdy.ai/ai/img_res/edited_c7e9c9aa027034e7b4b3bf331acb2c36_4d9c823a.jpg',
  },
  {
    id: 2,
    name: 'Home & Kitchen Appliances',
    tagline: 'Refrigerators · Washing Machines · Mixers · Cooktops',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20and%20kitchen%20appliances%20collection%20on%20clean%20white%20display%2C%20stainless%20steel%20refrigerator%20washing%20machine%20mixer%20grinder%20induction%20cooktop%20arranged%20neatly%2C%20minimal%20showroom%20setting%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=600&seq=product-appliances-01&orientation=landscape',
  },
  {
    id: 3,
    name: 'Smart TV & LCD TV',
    tagline: '4K UHD · Android Smart · LED Display · Full HD',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20TV%20on%20sleek%20white%20stand%20display%2C%20large%20flat%20screen%20showing%20vivid%20colorful%20interface%2C%20clean%20minimal%20showroom%20setting%2C%20soft%20ambient%20lighting%2C%20product%20photography%20style%2C%20warm%20neutral%20tones%2C%20high%20detail%20editorial%20composition&width=800&height=600&seq=product-tv-01&orientation=landscape',
  },
  {
    id: 4,
    name: 'DTH & Recharges',
    tagline: 'All Operators · Set-Top Boxes · Installation & Service',
    image: 'https://readdy.ai/api/search-image?query=DTH%20set-top%20box%20and%20satellite%20dish%20equipment%20on%20clean%20white%20display%2C%20modern%20digital%20receiver%20with%20remote%20control%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20clean%20editorial%20style%2C%20high%20detail%20composition&width=800&height=600&seq=product-dth-01&orientation=landscape',
  },
  {
    id: 5,
    name: 'Money Transfer',
    tagline: 'Safe · Quick · Trusted Banking Partners',
    image: 'https://readdy.ai/api/search-image?query=Digital%20money%20transfer%20concept%20with%20smartphone%20and%20credit%20cards%20on%20clean%20white%20surface%2C%20secure%20payment%20illustration%2C%20modern%20minimal%20style%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=600&seq=product-money-01&orientation=landscape',
  },
  {
    id: 6,
    name: 'Accessories & Gadgets',
    tagline: 'Cases · Chargers · Earphones · Smartwatches · Speakers',
    image: 'https://readdy.ai/api/search-image?query=Mobile%20accessories%20collection%20on%20white%20display%20table%2C%20phone%20cases%20charging%20cables%20earphones%20screen%20protectors%20power%20banks%20neatly%20arranged%2C%20clean%20minimal%20composition%2C%20soft%20studio%20lighting%2C%20professional%20retail%20product%20photography%2C%20warm%20neutral%20background&width=800&height=600&seq=product-accessories-01&orientation=landscape',
  },
  {
    id: 7,
    name: 'Visit Our Store',
    tagline: 'Step into Ashok Communication — Your trusted local shop',
    image: 'https://public.readdy.ai/ai/img_res/edited_e5ac3e3d8e681a2fdd33071cdd122063_6f33fcd8.jpg',
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.1, ease: 'easeOut' },
  }),
};

export default function ProductsGallery() {
  return (
    <section id="products" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block bg-primary-100 text-primary-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
            Our Collection
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Products We Offer
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Browse through mobiles, home appliances, TVs, DTH, money transfer, and accessories — everything under one roof.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-60px' }}
              variants={cardVariants}
              whileHover={{ y: -8, transition: { duration: 0.25 } }}
              className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-colors duration-300 cursor-default shadow-sm hover:shadow-lg"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-1">
                    {product.name}
                  </h3>
                  <p className="text-background-200 text-xs md:text-sm">
                    {product.tagline}
                  </p>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <a
                  href="#contact"
                  className="block text-center bg-primary-500 hover:bg-primary-600 text-background-50 font-medium py-2.5 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
                >
                  {product.id === 7 ? 'Find Us' : 'Inquire Now'}
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}